import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative h-[642px] overflow-hidden rounded-b-[20px] border-x-0 border-b-3 border-white/80 shadow-[inset_0_0_1px_rgba(0,0,0,0.05)] lg:-mt-[155px] lg:h-[704px] lg:rounded-b-[40px]',
    picture: 'absolute inset-0',
    bg: 'h-full w-full object-cover object-center',
    content:
      'absolute right-0 bottom-0 left-0 mx-auto flex flex-col-reverse max-lg:px-5 lg:w-fit lg:flex-row lg:gap-5 lg:pl-[29px] xl:gap-[100px]',
    productsImage:
      'relative z-1 mx-auto max-w-[320px] max-lg:pl-[10px] lg:max-w-[456px]',
    logoBlock:
      'landing-glass flex-center mx-auto max-w-[334px] gap-7 rounded-[20px] border-x-0 bg-white/5 px-8 py-[22px] shadow-[inset_0_6px_28px_rgba(0,0,0,0.02),inset_0_-6px_28px_rgba(0,0,0,0.04),inset_0_0_1px_rgba(0,0,0,0.05)] backdrop-saturate-140 lg:max-w-[582px] lg:rounded-[40px] lg:px-10 lg:py-12 xl:px-20',
    logoBlockDivider: 'bg-brand-bioderma w-px shrink-0 self-stretch',
    logoBlockImage: 'max-w-[107px] lg:max-w-[174px]',
    logoBlockText:
      'text-brand-bioderma text-left text-[20px] leading-[1.1] font-black uppercase lg:text-[32px]',
    title:
      'flex-center mt-[18px] mb-[6px] gap-3 text-[24px] leading-[1.1] font-black uppercase lg:mt-12 lg:text-[32px]',
    description:
      'text-brand-bioderma text-[18px] leading-[1.2] font-medium lg:text-[20px]',
    productsImageWrapper: '',
    logoBlockWrapper: 'text-center lg:mt-[70px]',
    bioderma: 'text-brand-bioderma',
    sensibio: 'text-[#E0457B]',
    divider: 'text-brand-bioderma text-[16px]',
    sup: 'align-middle text-[10px]'
  }
});
